import { setupFormState } from '@/components/form/tidal-form'
import { FormOrderStep, OrderFormValues } from './typings'

export const form = setupFormState<OrderFormValues>({
  id: 'orderForm',
  initialValues: {
    order: {} as uui.domain.client.rm.Order,
    orderStep: {} as FormOrderStep,
    type: 'p',
    recurrenceSettings: {} as uui.domain.ui.forms.RecurrenceSettings,
  },
})
